var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isOutOfSync)?_c('div',{staticClass:"text-center text-subtitle-2",staticStyle:{"font-size":"16px"}},[_vm._v(" Datos desactualizados (se recomienda consultar nuevamente) ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }